import { useQuery } from '@tanstack/react-query';

import { useAvApi } from '@app-velocity/av-api-v2';

import { getDiscussionRefetchInterval } from '@app-velocity/common';

export const useGetChatConversationMessagesQuery = (
  shareToken?: string,
  messageId?: string,
  enabled = true
) => {
  const { prototypesShare } = useAvApi();

  return useQuery({
    enabled: enabled && !!shareToken && !!messageId,
    queryKey: ['chat-conversation', 'figma', shareToken, messageId],
    queryFn: async () => {
      if (!shareToken || !messageId) return;

      const data =
        await prototypesShare.getV2PrototypesShareAiChatMessagesConversationByShareTokenAndMessageId(
          {
            shareToken,
            messageId,
          }
        );

      return data.data;
    },
    refetchInterval: getDiscussionRefetchInterval,
  });
};
